module.exports = "<select class=\"w3-select w3-block w3-border w3-round\"\r\n  [(ngModel)]=\"value\"\r\n  [disabled]=\"isDisabled\">\r\n  <option *ngFor=\"let size of containerSizes\" [value]=\"size\">{{size}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/ztsi-container-size-select/ztsi-container-size-select.component.html
// module id = ./src/app/components/shared/ztsi-container-size-select/ztsi-container-size-select.component.html
// module chunks = main